module.exports = __webpack_public_path__ + "img/sparkiez_logo.615642fa.png";